import React, { useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteFiscalYear } from '../../../../slices/fiscalYear/thunk';

const DeleteFiscalYearModal = ({ data, isOpen, toggle }) => {
	const dispatch = useDispatch();

	const selector = createSelector(
		state => state.FiscalYear,
		fiscalYear => ({
			isDeleting: fiscalYear.isLoading, // Assuming isLoading covers deleting state
		})
	);

	const { isDeleting } = useSelector(selector);

	const handleDelete = () => {
		if (data && data._id) {
			dispatch(deleteFiscalYear(data));
			toggle();
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			toggle={toggle}
			size='sm'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader className='modal-title' toggle={toggle} />
			<ModalBody className='text-center p-3'>
				<lord-icon
					src='https://cdn.lordicon.com/tdrtiskw.json'
					trigger='loop'
					colors='primary:#f06548,secondary:#405189'
					style={{ width: '90px', height: '90px' }}
				></lord-icon>
				<div className='mt-2'>
					<h3 className='mb-3'>
						¡Estás a punto de eliminar un año fiscal!
					</h3>
					<p className='text-muted mb-4'>
						Si deseas realizar esta acción debes hacer click en confirmar.
					</p>
					<p className='small'>Año fiscal: {data ? data.name : ''}</p>
					<div className='hstack gap-2 justify-content-center'>
						<Button className='btn-danger btn-label' onClick={toggle}>
							<i className='icon-x label-icon'></i> Cancelar
						</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={handleDelete}
							disabled={isDeleting}
						>
							{isDeleting ? (
								<i className='label-icon'>
									<Spinner size='sm' />
								</i>
							) : (
								<i className={`${Icons.check2} label-icon`}></i>
							)}{' '}
							Confirmar
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default DeleteFiscalYearModal;
